import UnlockIcon from '@assets/icons/UnlockIcon'
import { tabletQuery } from '@globals/themes/themeConstants'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Button from '@mui/material/Button'
import useMediaQuery from '@mui/material/useMediaQuery'
import { T, useT } from '@transifex/react'
import { Control, FieldValues, Path, useController } from 'react-hook-form'

type PublicPrivateFieldProps<T extends FieldValues> = {
  name: Path<T>
  control: Control<T>
  topMargin?: number
  onChange?: (value: boolean) => void
}

const PublicPrivateField = <T extends FieldValues>({
  control,
  name,
  topMargin = 2,
  onChange: onChangeProp,
}: PublicPrivateFieldProps<T>) => {
  const t = useT()
  const isTablet = useMediaQuery(tabletQuery)

  const {
    field: { value, onChange },
  } = useController({ control, name })

  const buttonText = () => {
    if (isTablet) {
      return value ? <T _str="Public" /> : <T _str="Private" />
    }
    return value ? <T _str="This post is public" /> : <T _str="This post is private" />
  }

  return (
    <Button
      variant="text"
      id="btnPublicPrivate"
      sx={{ mt: topMargin }}
      onClick={() => {
        onChange(!value)
        if (onChangeProp) {
          onChangeProp(!value)
        }
      }}
      aria-label={value ? t('Set to private') : t('Set to public')}
      startIcon={value ? <UnlockIcon /> : <LockOutlinedIcon />}>
      {buttonText()}
    </Button>
  )
}

export default PublicPrivateField
